import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-601fc8fe"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "navbar-toggler-icon"
}, null, -1));

const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "navbar-nav navbar-collapse collapse",
  id: "navbarColor02"
};
const _hoisted_4 = {
  id: "categorylist",
  class: "navbar-nav mr-auto d-flex align-items-center"
};
const _hoisted_5 = ["name"];
import { ref } from "vue";
export default {
  __name: 'HomeBlogNav',
  props: {
    menu: {
      required: true,
      type: Array
    }
  },

  setup(__props) {
    const topBarExpand = ref(false);
    const btnRef = ref(null);
    const bgW = "bg-white";
    const bgW50 = "bg-white-50";

    function scrollIntoView(event) {
      if (event) {
        let el = document.getElementById("div-" + event.target.name);

        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: 'center'
          });

          if (window.getComputedStyle(btnRef.value).getPropertyValue('display') !== 'none') {
            btnRef.value.click();
          }
        }
      }
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("nav", {
        class: _normalizeClass(["navbar navbar-blog sticky-top", topBarExpand.value ? bgW : bgW50])
      }, [_createElementVNode("button", {
        ref_key: "btnRef",
        ref: btnRef,
        class: "navbar-toggler collapsed",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarColor02",
        "aria-controls": "navbarColor02",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation",
        onClick: _cache[0] || (_cache[0] = $event => topBarExpand.value = !topBarExpand.value)
      }, _hoisted_2, 512), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, item => {
        return _openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: item.sname
        }, [_createElementVNode("a", {
          class: "nav-link category-item",
          style: {
            "padding-right": "0rem"
          },
          onClick: scrollIntoView,
          name: item.sname
        }, _toDisplayString(item.sname), 9, _hoisted_5)]);
      }), 128))])])], 2);
    };
  }

};